/**
 * 埋点辅助工具
 * 简化埋点上报，自动注入供应商信息
 */

import { reportLx } from '@lsfe/tools';
import { getSupplierInfoForTracking } from './supplierInfoManager';

/**
 * 上报 PV 埋点（自动注入供应商信息）
 * @param {Object} vm - Vue 实例
 * @param {String} cid - 页面 CID
 * @param {Object} customParams - 自定义参数
 * @returns {Promise<void>}
 */
export async function reportPageView(vm, cid, customParams = {}) {
    try {
        const supplierInfo = await getSupplierInfoForTracking(vm);
        reportLx('pageView', {
            custom: {
                ...supplierInfo,
                ...customParams,
            },
        }, null, cid);
    } catch (error) {
        console.error('PV 埋点上报失败:', error);
    }
}

/**
 * 上报模块曝光埋点（自动注入供应商信息）
 * @param {Object} vm - Vue 实例
 * @param {String} bid - 埋点 BID
 * @param {Object} customParams - 自定义参数
 * @param {Object} options - 其他选项（如 cid, delay 等）
 * @returns {Promise<void>}
 */
export async function reportModuleView(vm, bid, customParams = {}, options = {}) {
    try {
        const supplierInfo = await getSupplierInfoForTracking(vm);
        // 如果没有传 cid，默认使用首页的 cid
        const finalOptions = {
            ...options,
        };
        if (!finalOptions.cid) {
            finalOptions.cid = 'c_chaoshi_8w3nsc1q';
        }

        reportLx('moduleView', bid, {
            ...supplierInfo,
            ...customParams,
        }, finalOptions);
    } catch (error) {
        console.error('模块曝光埋点上报失败:', error);
    }
}

/**
 * 上报点击埋点（自动注入供应商信息）
 * @param {Object} vm - Vue 实例
 * @param {String} bid - 埋点 BID
 * @param {Object} customParams - 自定义参数
 * @param {Object} options - 其他选项（如 cid 等）
 * @returns {Promise<void>}
 */
export async function reportModuleClick(vm, bid, customParams = {}, options = {}) {
    try {
        const supplierInfo = await getSupplierInfoForTracking(vm);
        // 如果没有传 cid，默认使用首页的 cid
        const finalOptions = {
            ...options,
        };
        if (!finalOptions.cid) {
            finalOptions.cid = 'c_chaoshi_8w3nsc1q';
        }

        reportLx('moduleClick', bid, {
            ...supplierInfo,
            ...customParams,
        }, finalOptions);
    } catch (error) {
        console.error('点击埋点上报失败:', error);
    }
}
